import eventBus from "@voix/utils/voixEventBus";
import { setupVoixUserXP } from "@voix/utils/voixUserXP";
export default (voix) => {
  voix.eventBus = eventBus;
  setupVoixUserXP(voix);
  return voix;
};
